import $ from 'jquery';
import 'select2';

export default function initM30() {
    $(".mobileNav").select2().each(function () {
        $(this).on('change', function () {
            let select_el = $(this);
            let select_val = select_el.val();
            if (/(http(s?)):\/\//i.test(select_val)) {
                window.location.href = select_val;
            } else {
                $("html, body").animate({ scrollTop: $(select_val).offset().top - $('.siteHeader').outerHeight() }, 500, function () {
                    select_el.val('')
                });
            }
        })
    })
}